<template>
  <div class="px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
    <div class="flex-1 flex justify-between sm:hidden">
      <a @click="changePage(page - 1)" v-if="page > 1" href="javascript:;" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"> 上一页 </a>
      <a @click="changePage(page + 1)" v-if="page < pageCount" href="javascript:;" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"> 下一页 </a>
    </div>
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          共
          <span class="font-medium">{{ total }}</span>
          条数据
          <span class="inline-block mr-2"></span>
          当前第
          <span class="font-medium">{{ page }}</span>
          页
          <span class="inline-block mr-2"></span>
          共
          <span class="font-medium">{{ pageCount }}</span>
          页
        </p>
      </div>
      <div>
        <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
          <a href="javascript:;" @click="changePage(page - 1)" :class="{'cursor-not-allowed': page < 2, 'disabled:opacity-50': page < 2 }" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
            <span class="sr-only">上一页</span>
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </a>
          <a
            href="javascript:;"
            aria-current="page"
            v-if="pageCount > 0"
            @click="changePage(1)"
            :class="{'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 cursor-default': page === 1}"
            class="relative inline-flex items-center px-4 py-2 border text-sm font-medium">
            1
          </a>
          <span v-if="showPrevMore" class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"> ... </span>
          <a
            href="javascript:;"
            aria-current="page"
            v-for="pager in pagers"
            @click="changePage(pager)"
            :key="pager"
            :class="{'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 cursor-default': page === pager}"
            class="relative inline-flex items-center px-4 py-2 border text-sm font-medium">
            {{ pager }}
          </a>
          <span v-if="showNextMore" class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"> ... </span>
          <a
            href="javascript:;"
            v-if="pageCount > 1"
            @click="changePage(pageCount)"
            aria-current="page"
            :class="{'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 cursor-default': pageCount === page}"
            class="relative inline-flex items-center px-4 py-2 border text-sm font-medium">
            {{ pageCount }}
          </a>
          <a @click="changePage(page + 1)" href="javascript:;" :class="{'cursor-not-allowed': pageCount === page  }" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
            <span class="sr-only">下一页</span>
            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationComponent',
  props: {
    size: {
      type: Number,
      default: 10
    },
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      pagerCount: 7,
      showPrevMore: false,
      showNextMore: false
    }
  },
  methods: {
    changePage (page) {
      if (page === this.page) return
      if (page < 1) return
      if (page > this.pageCount) return
      this.$emit('change', page)
    }
  },
  computed: {
    pageCount () {
      if (!parseInt(this.total)) return 1
      return Math.max(1, Math.ceil(parseInt(this.total) / this.size))
    },
    pagers () {
      const pagerCount = this.pagerCount;
      const halfPagerCount = (pagerCount - 1) / 2;

      const currentPage = Number(this.page);
      const pageCount = Number(this.pageCount);

      let showPrevMore = false;
      let showNextMore = false;

      if (pageCount > pagerCount) {
        if (currentPage > pagerCount - halfPagerCount) {
          showPrevMore = true;
        }

        if (currentPage < pageCount - halfPagerCount) {
          showNextMore = true;
        }
      }

      const array = [];

      if (showPrevMore && !showNextMore) {
        const startPage = pageCount - (pagerCount - 2);
        for (let i = startPage; i < pageCount; i++) {
          array.push(i);
        }
      } else if (!showPrevMore && showNextMore) {
        for (let i = 2; i < pagerCount; i++) {
          array.push(i);
        }
      } else if (showPrevMore && showNextMore) {
        const offset = Math.floor(pagerCount / 2) - 1;
        for (let i = currentPage - offset ; i <= currentPage + offset; i++) {
          array.push(i);
        }
      } else {
        for (let i = 2; i < pageCount; i++) {
          array.push(i);
        }
      }

      /* eslint-disable */
      this.showPrevMore = showPrevMore;
      this.showNextMore = showNextMore;
      /* eslint-disable */

      return array;
    }
  },
}
</script>
